<template>
  <b-row class="header-purchase no-gutters"
         :class="{'no-padding': banner}">
    <b-col class="container-header-purchase">
      <p class="title"
         :class="{'no-mobile': banner}">
        {{ title }}
      </p>
      <b-row class="container-bottom no-gutters">
        <b-col cols="12"
               sm="4"
               :class="{'no-mobile': banner}">
          <p v-if="type === 1 && checkDates"
             class="event-date">
            <span class="icon icon-calendar" />{{ startDate | moment('utc', 'DD MMM YY') }} - {{ endDate | moment('DD MMM YY') }}
          </p>
          <p v-else-if="type === 1 && !checkDates"
             class="event-date">
            <span class="icon icon-calendar" />{{ startDate | moment('utc', 'DD MMM') }} - {{ endDate | moment('DD MMM') }} - {{ startDate | moment('YY') }}
          </p>
          <p v-else
             class="event-date">
            <span class="icon icon-calendar" />{{ startDate | moment('utc', 'DD MMM YY') }}
          </p>
        </b-col>
        <b-col cols="12"
               sm="4"
               :class="{'no-mobile': banner}">
          <p class="event-time">
            <span class="icon icon-clock" />{{ startDate | moment('utc','HH:mm') }}h
          </p>
        </b-col>
        <b-col v-if="venue"
               class="container-venue"
               cols="12"
               sm="4"
               :class="{'no-mobile': banner}">
          <div class="container-icon-venue">
            <span class="icon icon-location" />
          </div>
          <div class="container-info-venue">
            <span v-if="venue.name"
                  class="venue-name ellipsis">{{ venue.name }}</span>
            <span v-if="venue.address"
                  class="venue-address ellipsis">{{ venue.address }}</span>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    startDate: {
      type: String,
      default: ''
    },
    endDate: {
      type: String,
      default: ''
    },
    type: {
      type: Number,
      default: 0
    },
    venue: {
      type: Object,
      default: () => {}
    },
    banner: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    checkDates() {
      if (
        this.$moment(this.$store.state.event.detail.startDate).year() !==
        this.$moment(this.$store.state.event.detail.endDate).year()
      )
        return true
    }
  }
}
</script>

<style lang="scss">
@import './header-purchase.sass';
</style>
